import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PaymentInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-top: 1px solid #E1E1E1;
  border-bottom: 1px solid #E1E1E1;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    background-color: #F8F8F8;
  }
`;

export const MastercardLogo = styled.div`
  width: 48px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CardDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardNumber = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
`;

export const ExpiryDate = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #9A999A;
`;

export const ChangeCardButton = styled.button`
  background: none;
  border: 1px solid #9B5AF8;
  border-radius: 4px;
  color: #9B5AF8;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #F8F5FF;
  }
  
  &:focus {
    outline: none;
  }
`;

export const AddPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  border-top: 1px solid #E1E1E1;
  border-bottom: 1px solid #E1E1E1;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    background-color: #F8F8F8;
  }
`;

export const AddPaymentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PaymentTitle = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #0F0F0F;
`;

export const PaymentDescription = styled.div`
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #565556;
  margin-left: 36px;
`; 